export default "__VITE_ASSET__f36d6cf3__"